document.querySelectorAll('[data-header]').forEach((header) => {
  const toggle = header.querySelector('[data-menu-toggle]');
  const close = header.querySelector('[data-menu-close]');
  const menu = header.querySelector('[data-mobile-menu]');
  const backdrop = header.querySelector('[data-menu-backdrop]');
  const submenuToggles = header.querySelectorAll('[data-mobile-submenu-toggle]');
  const search = header.querySelector('.ptc-header__search');
  const mobileViewport = window.matchMedia('(max-width: 1279px)');
  let lastScrollY = Math.max(window.scrollY, 0);
  let scrollTicking = false;

  const showMobileTools = () => header.classList.remove('is-search-collapsed');
  const updateMobileTools = () => {
    scrollTicking = false;
    const currentY = Math.max(window.scrollY, 0);
    const delta = currentY - lastScrollY;

    header.classList.toggle('is-scrolled', currentY > 24);

    if (!mobileViewport.matches || currentY <= 12 || search?.contains(document.activeElement) || (menu && !menu.hidden)) {
      showMobileTools();
    } else if (delta > 5) {
      header.classList.add('is-search-collapsed');
    } else if (delta < -4) {
      showMobileTools();
    }

    lastScrollY = currentY;
  };

  window.addEventListener('scroll', () => {
    if (scrollTicking) return;
    scrollTicking = true;
    window.requestAnimationFrame(updateMobileTools);
  }, { passive: true });

  mobileViewport.addEventListener('change', () => {
    lastScrollY = Math.max(window.scrollY, 0);
    updateMobileTools();
  });

  updateMobileTools();

  if (!toggle || !menu) return;

  const setOpen = (open) => {
    menu.hidden = !open;
    if (backdrop) backdrop.hidden = !open;
    toggle.setAttribute('aria-expanded', String(open));
    document.documentElement.classList.toggle('menu-open', open);
    if (open) showMobileTools();
    if (!open) {
      submenuToggles.forEach((submenuToggle) => {
        const submenu = document.getElementById(submenuToggle.getAttribute('aria-controls'));
        if (submenu) submenu.hidden = true;
        submenuToggle.setAttribute('aria-expanded', 'false');
      });
    }
    if (open) close?.focus(); else toggle.focus();
  };

  toggle.addEventListener('click', () => setOpen(menu.hidden));
  close?.addEventListener('click', () => setOpen(false));
  backdrop?.addEventListener('click', () => setOpen(false));
  submenuToggles.forEach((submenuToggle) => {
    const submenu = document.getElementById(submenuToggle.getAttribute('aria-controls'));
    if (!submenu) return;
    submenuToggle.addEventListener('click', () => {
      const open = submenu.hidden;
      submenu.hidden = !open;
      submenuToggle.setAttribute('aria-expanded', String(open));
    });
  });
  mobileViewport.addEventListener('change', (event) => {
    if (!event.matches && !menu.hidden) setOpen(false);
  });
  document.addEventListener('keydown', (event) => {
    if (menu.hidden) return;
    if (event.key === 'Escape') {
      setOpen(false);
      return;
    }
    if (event.key !== 'Tab') return;
    const focusable = [...menu.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')]
      .filter((element) => !element.hidden && element.getClientRects().length);
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });
});
